<template>
  <div class="page modal-page-scroll d-flex flex-column">
    <div class="row header-page w-100">
      <div class="col-12 mb-4">
        <h2>
          GeneraSviluppo Sostenibile
        </h2>
      </div>
      <div class="col-12">
        <b-tabs pills class="list-tabs w-100">
          <b-tab title="La nostra soluzione">
            <b-card-text>
              <div class="row">
                <div class="col-12 popup-description">
                  <div class="h4-medium mt-2 mb-2">
                    GeneraSviluppo Sostenibile, i perché di una scelta:
                  </div>
                  <div>
                    <strong>Perché la sostenibilità crea valore</strong><br />
                    Le aziende attente alla sostenibilità hanno dimostrato di saper crescere di
                    più e meglio. Investire in queste aziende è un’azione
                    responsabile e offre nel tempo maggiori opportunità di
                    rendimento.
                    <br /><br />
                    <strong
                      >Perché è importante dare stabilità al tuo
                      investimento</strong
                    ><br />
                    Affiancando a portafogli che investono in aziende
                    attente alla sostenibilità GESAV, solida Gestione separata assicurativa che
                    vanta un patrimonio di oltre 46 miliardi di Euro.
                    <br /><br />
                    <strong>Perché vuoi proteggere i tuoi cari</strong><br />
                    Scegliendo il servizio TUTELA dai a chi ami la serenità per
                    affrontare il futuro.
                  </div>
                </div>
                <div class="col-5" v-if="false">
                  <img
                    alt="SDG"
                    src="../../assets/images/icone-ambiti/ruota.svg"
                    class="ambiti-image ml-auto d-block"
                  />
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-6" v-for="area in areaList" :key="area.id">
                  <area-panel
                    :area="area"
                    :svg="require('../../assets/images/banner/03-main.svg')"
                  ></area-panel>
                </div>
              </div>
            </b-card-text>
          </b-tab>
          <b-tab title="Obiettivi per lo sviluppo sostenibile">
            <b-card-text>
              <div class="row">
                <div class="col-12">
                  <div class="h4-medium mt-2 mb-2">
                    Obiettivi per lo sviluppo sostenibile
                  </div>
                  <div class="popup-description mb-4">
                    Nel 2015 i leader mondiali hanno concordato 17 obiettivi per
                    un mondo migliore entro il 2030. Tutti siamo coinvolti in
                    una sfida globale da qui ai prossimi decenni. Temi
                    fondamentali come il clima, il consumo e la produzione
                    responsabili, l’uguaglianza di genere, o le città
                    sostenibili, fanno parte di un cambiamento positivo che ci
                    riguarda ormai da vicino perché ognuno di noi può fare
                    qualcosa per migliorare il futuro di tutti.
                  </div>
                  <div class="mb-3">
                    <img
                      alt="Icone SDG"
                      src="../../assets/images/icone-sdg/sdg-img@2x.png"
                      class="sdg-image"
                    />
                  </div>
                  <div>
                    <div class="row mt-3">
                      <div class="col-6" v-for="sdg in sdgList" :key="sdg.id">
                        <sdg-panel
                          :title="sdg.title"
                          :text="sdg.desc"
                          :icon="sdg.icon"
                        ></sdg-panel>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-card-text>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import SdgPanel from "../../components/SdgPanel";
import AreaPanel from "../../components/AreaPanel";
import { getAreaListData } from "../../data/area-list.data";
export default {
  name: "GeneraSviluppoSostenibile",
  components: { SdgPanel, AreaPanel },
  data: () => {
    return {
      sdgList: [],
      areaList: []
    };
  },
  created() {
    this.areaList = JSON.parse(JSON.stringify(getAreaListData([])));
    let list = [];
    this.areaList.filter(a => {
      list = [...list, ...a.sdg];
    });
    this.sdgList = list.sort((a, b) => a.id - b.id);
  }
};
</script>

<style scoped></style>
